import type { RequestRestService } from '../RequestRestService'
import type { HttpClient } from '~/shared/api'
import { ApiService, toModels } from '~/shared/api'
import type { Logger } from '~/shared/interfaces'
import { Article, ArticleCard } from '~/models/articles'
import { API_PREFIX } from '~/shared/const/request-services'
import { unwrapDataOrBody } from '~/shared/utils/response'

export class ArticleDetailService extends ApiService {
  constructor(
    private readonly requestRest: RequestRestService,
    http: HttpClient,
    private readonly logger: Logger,
  ) {
    super(http)
  }

  async getBySlug(slug: string): Promise<Article> {
    const response = await this.requestRest.getItem('news', slug)
    return new Article(unwrapDataOrBody(response))
  }

  getRecommendations(excludeIds: number[] = []): Promise<ArticleCard[]> {
    const params: Record<string, number | number[]> = { per_page: 10 }
    excludeIds.forEach((id, idx) => {
      params[`exclude_ids[${idx}]`] = id
    })

    return this.http
      .request({ url: `${API_PREFIX}/news/latest`, params })
      .then(toModels(ArticleCard))
  }

  getEditorsChoice(excludeIds: number[] = []): Promise<ArticleCard[]> {
    const params: Record<string, number | number[]> = {}
    excludeIds.forEach((id, idx) => {
      params[`exclude_ids[${idx}]`] = id
    })

    return this.http
      .request({ url: `${API_PREFIX}/news/editors-choice`, params })
      .then(toModels(ArticleCard))
  }

  async addViewCount(slug: string): Promise<void> {
    try {
      await this.http.request({ method: 'POST', url: `${API_PREFIX}/news/${slug}/count-views` })
    }
    catch (error) {
      this.logger.warn(`Failed to count view for "${slug}"`, error)
    }
  }
}
